import careerAndWork from '@packages/shared/assets/simple-registration/experiment/career-and-work.svg';
import loveAndRelationship from '@packages/shared/assets/simple-registration/experiment/love-and-relationship.svg';
import destinyAndLifePath from '@packages/shared/assets/simple-registration/experiment/destiny-and-life-path.svg';
import futureTelling from '@packages/shared/assets/simple-registration/experiment/future-telling.svg';
import spiritGuidance from '@packages/shared/assets/simple-registration/experiment/spirit-guidance.svg';
import other from '@packages/shared/assets/simple-registration/experiment/other.svg';
import tarotReading from '@packages/shared/assets/simple-registration/experiment/tarot-reading.png';
import loveReading from '@packages/shared/assets/simple-registration/experiment/love-reading.png';
import numerologyAnalysis from '@packages/shared/assets/simple-registration/experiment/numerology-analysis.svg';
import astrologyAndHoroscope from '@packages/shared/assets/simple-registration/experiment/astrology-and-horoscope.png';
import dreamAnalysis from '@packages/shared/assets/simple-registration/experiment/dream-analysis.svg';
import time from '@packages/shared/assets/simple-registration/experiment/time-colored.svg';
import female from '@packages/shared/assets/simple-registration/experiment/female.svg';
import male from '@packages/shared/assets/simple-registration/experiment/male.svg';
import lovePlanet from '@packages/shared/assets/simple-registration/love-planet.png';
import emailConsent from '@packages/shared/assets/simple-registration/email-consent.png';
import { DEFAULT_FREE_MINUTES } from '@packages/shared/core/common/constants/appDefaults';
import { PagePath } from '@packages/shared/core/common/constants/routes';
import { UserState } from '@packages/shared/core/user/store/state';
import { QUIZ_ANALYTIC_EVENTS } from '@packages/shared/core/analytics/events';
import {
  AreaOfGuidance,
  ExpertsCatalogueStepData,
  FlowName,
  QuizData,
  StepTypes,
} from '@packages/shared/core/quiz/entities';
import { Specializations } from '@packages/shared/core/experts/entities';
import { requireEmailConsentFeature } from '@packages/shared/core/feature-flags/config';

const usDisclaimer =
  '<span style=\"display: block; text-align: center;\">By clicking any option (\"Male\" or \"Female\"), you agree to the <a href=\"https://asknebula.com/app/terms\" style=\"color:#8E8CF0; text-decoration:none;\">Terms of Use</a>, <a href=\"https://asknebula.com/app/privacy\" style=\"color:#8E8CF0; text-decoration:none;\">Privacy Policy</a>, <a href=\"https://asknebula.com/app/cookie-policy\" style=\"color:#8E8CF0; text-decoration:none;\">Cookie Policy</a>, and to the use of cookies and tracking technologies that require your consent (e.g., Meta Pixel)<br><br>For entertainment purposes only.<br>Yolo Brothers Inc., 500 North Rainbow Blvd, Suite300, Las Vegas, Nevada 89107</span>';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const chinaDisclaimer =
  '<span style="display: block; text-align: center;">By tapping "Male" or "Female", you agree to the <a href=https://asknebula.com/app/terms style="color:#8E8CF0; text-decoration:none;">Terms of Use</a>, <a href=https://asknebula.com/app/privacy style="color:#8E8CF0; text-decoration:none;">Privacy Policy</a><br><br>For entertainment purposes only.<br>SGR Hong Kong Limited, Suite 3201, Jardine House, 1 Connaught Place, Central, Hong Kong</span>';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const defaultDisclaimer =
  '<span style="display: block; text-align: center;">By tapping "Male" or "Female", you agree to the <a href=https://asknebula.com/app/terms style="color:#8E8CF0; text-decoration:none;">Terms of Use</a>, <a href=https://asknebula.com/app/privacy style="color:#8E8CF0; text-decoration:none;">Privacy Policy</a><br><br>For entertainment purposes only.<br>Spiritual Nebula Limited, 62 Athalassas Avenue, Mezzanine Floor, Strovolos, 2012 Nicosia, Cyprus</span>';
export const quizResources: QuizData = {
  name: FlowName.SIMPLE_SIMPLE_REGISTRATION,
  baseUrl: PagePath.SIMPLE_SIMPLE_REGISTRATION_QUIZ,
  previousStage: PagePath.HOME,
  nextStage: PagePath.POST_QUIZ,
  initialId: 'gender',
  lastId: 'offer',
  steps: {
    gender: {
      id: 'gender',
      next: 'topicToDiscuss',
      prev: null,
      dataKey: 'gender',
      totalSteps: 4,
      index: 1,
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.SIMPLE_QUIZ_GENDER_OPEN,
        clickEvent: QUIZ_ANALYTIC_EVENTS.SIMPLE_QUIZ_GENDER_CLICK,
      },
      content: {
        title: 'What is your gender?',
        answers: [
          {
            text: 'Female',
            emoji: female,
            value: 'female',
          },
          {
            text: 'Male',
            emoji: male,
            value: 'male',
          },
        ],
        disclaimer: usDisclaimer,
      },
      screenType: StepTypes.SINGLE_ANSWER,
    },
    topicToDiscuss: {
      id: 'topicToDiscuss',
      next: 'typeOfReading',
      prev: 'gender',
      dataKey: 'topicToDiscuss',
      totalSteps: 4,
      index: 2,
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.SIMPLE_QUIZ_OPEN,
        clickEvent: QUIZ_ANALYTIC_EVENTS.SIMPLE_QUIZ_CLICK,
      },
      otherOpenEvent: QUIZ_ANALYTIC_EVENTS.SIMPLE_QUIZ_OPEN_OTHER,
      otherClickEvent: QUIZ_ANALYTIC_EVENTS.SIMPLE_QUIZ_CLICK_OTHER,
      content: {
        title: 'What topic do you want to get answers from a psychic?',
        modalButton: 'Send your answer',
        modalTitle: 'Enter the topic you are interested in',
        list: [
          {
            text: AreaOfGuidance.LOVE_AND_RELATIONSHIP,
            icon: loveAndRelationship,
          },
          {
            text: AreaOfGuidance.CAREER_AND_WORK,
            icon: careerAndWork,
          },
          {
            text: AreaOfGuidance.DESTINY_AND_LIFE_PATH,
            icon: destinyAndLifePath,
          },
          {
            text: AreaOfGuidance.FUTURE_TELLING,
            icon: futureTelling,
          },
          {
            text: AreaOfGuidance.SPIRIT_GUIDANCE,
            icon: spiritGuidance,
          },
          {
            text: AreaOfGuidance.OTHER,
            icon: other,
          },
        ],
      },
      screenType: StepTypes.TOPIC_TO_DISCUSS,
    },
    typeOfReading: {
      id: 'typeOfReading',
      next: 'date',
      prev: 'topicToDiscuss',
      dataKey: 'typeOfReading',
      totalSteps: 4,
      index: 3,
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.UNIQUE_SKILLS_SIMPLE_QUIZ_OPEN,
        clickEvent: QUIZ_ANALYTIC_EVENTS.UNIQUE_SKILLS_SIMPLE_QUIZ_CLICK,
      },
      content: {
        title: 'What type of reading are you interested in?',
        subtitle: 'Our psychics have unique fields of expertise and consultation experience.',
        list: [
          {
            text: 'Love Reading',
            icon: loveReading.src,
            value: Specializations.LOVE_READING,
          },
          {
            text: 'Tarot Reading',
            icon: tarotReading.src,
            value: Specializations.TAROT,
          },
          {
            text: 'Numerology Analysis',
            icon: numerologyAnalysis,
            value: Specializations.NUMEROLOGY,
          },
          {
            text: 'Astrology & Horoscope',
            icon: astrologyAndHoroscope.src,
            value: Specializations.ASTROLOGY,
          },
          {
            text: 'Fortune Telling',
            icon: futureTelling,
            value: Specializations.FORTUNE_TELLING,
          },
          {
            text: 'Dream Analysis',
            icon: dreamAnalysis,
            value: Specializations.DREAM_ANALYSIS,
          },
        ],
      },
      screenType: StepTypes.TYPE_OF_READING,
    },
    date: {
      id: 'date',
      next: 'processing',
      totalSteps: 4,
      index: 4,
      prev: 'typeOfReading',
      screenType: StepTypes.DATE,
      dataKey: 'date',
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.BIRTH_DATE_SIMPLE_QUIZ_OPEN,
        clickEvent: QUIZ_ANALYTIC_EVENTS.BIRTH_DATE_SIMPLE_QUIZ_CLICK,
      },
      content: {
        title: 'What is your date of birth?',
        subtitle: 'Your date of birth helps to determine your sun sign and compatibility with others.',

        disclaimer: 'You must be at least 18 years old to continue',
      },
    },
    processing: {
      id: 'processing',
      next: 'expertsCatalogue',
      prev: '',
      index: 0,
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.REGISTRATION_PROCESSING_PAGE_OPEN,
      },
      content: {
        title: 'Saving your reading preferences',
        stages: ['Analyzing your answers...', 'Fetching a list of available psychics...'],
        additionalTitleStart: '60 million people',
        additionalTitleEnd: 'have chosen Nebula',
      },
      screenType: StepTypes.PROCESSING,
    },
    expertsCatalogue: {
      id: 'expertsCatalogue',
      getStepData: ({ user }): ExpertsCatalogueStepData => {
        // TODO: CHAT-7932 bring back title and subtitle after the crisis
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const renderSubtitle = () => {
          if (Object.values(AreaOfGuidance).includes(user.topicToDiscuss)) {
            return `Your Preferences: ${user.topicToDiscuss} + ${user.typeOfReading.text}`;
          }
          return `Your Preferences: ${user.typeOfReading}`;
        };

        return {
          id: 'expertsCatalogue',
          next: 'signUp',
          prev: 'date',
          index: 4,
          dataKey: 'expertsCatalogue',
          analytic: {
            baseEvent: QUIZ_ANALYTIC_EVENTS.REGCAT_SIMPLE_QUIZ_OPEN,
            clickEvent: QUIZ_ANALYTIC_EVENTS.REGCAT_SIMPLE_QUIZ_CLICK,
          },
          content: {
            // title: 'Best psychics based on your answers',
            // subtitle: renderSubtitle(),
            button: 'Redeem Now',
            modalTitle: `Free ${DEFAULT_FREE_MINUTES} minutes`,
            modalDescription: 'First time here? Take advantage of your free minutes and get all answers now!',
            modalButton: 'Redeem Now',
            modalIcon: time,
          },
          screenType: StepTypes.EXPERTS_CATALOGUE,
        };
      },
    },
    signUp: {
      id: 'signUp',
      prev: 'expertsCatalogue',
      next: 'signUpSplit',
      index: 14,
      dataKey: 'sign-up',
      getGoal: () => {
        return '';
      },
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.REGFORM_SIMPLE_QUIZ_OPEN,
        clickEvent: QUIZ_ANALYTIC_EVENTS.REGFORM_SIMPLE_QUIZ_CLICK,
      },
      content: {
        title: 'Let’s set up your profile',
        subtitle: 'This is needed to save your data',
      },
      screenType: StepTypes.SIGN_UP,
    },
    signUpSplit: {
      id: 'signUpSplit',
      screenType: StepTypes.SPLIT,
      next: '',
      prev: '',
      content: {},
      index: 8,
      getStep: (userProfile: UserState) => {
        if (userProfile.emailAlreadyExists) {
          return 'signIn';
        }
        return 'password';
      },
    },
    signIn: {
      id: 'signIn',
      prev: 'signUp',
      next: '',
      index: 14,
      dataKey: 'sign-in',
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.REGISTRATION_WELCOME_BACK_OPEN,
      },
      getGoal: () => {
        return '';
      },
      content: {
        title: 'Welcome back!',
        subtitle: 'You already have an account, please enter your password to proceed.',
      },
      screenType: StepTypes.SIGN_IN,
    },
    password: {
      id: 'password',
      prev: 'signUp',
      next: 'phoneNumber',
      index: 14,
      dataKey: 'password',
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.REGISTRATION_PASSWORD_OPEN,
      },
      content: {
        title: 'Create a password',
        subtitle: "This is important so you don't lose all your information and save your progress.",
      },
      screenType: StepTypes.PASSWORD,
    },
    phoneNumber: {
      id: 'phoneNumber',
      prev: 'signUp',
      next: 'emailConsentRequirementSplit',
      index: 15,
      dataKey: 'phoneNumber',
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.SMS_INPUT_OPEN,
        baseEventProperties: {
          context: 'after_password',
          funnel_stage: 'quiz',
        },
      },
      content: {
        title: 'Never Miss Out!',
        titleImage: {
          src: lovePlanet.src,
          alt: 'love planet',
        },
        description: ["Enter your phone number to receive instant updates on your psychic's replies and availability."],
        guaranteeText: 'Opt-out anytime.',
        continueButtonText: 'Get personalized updates',
        skipButtonText: 'I don’t want updates',
        checkboxApproveText: 'I agree to receive marketing messages from Nebula',
      },
      screenType: StepTypes.PHONE_NUMBER,
    },
    emailConsentRequirementSplit: {
      id: 'emailConsentRequirementSplit',
      screenType: StepTypes.SPLIT,
      next: '',
      prev: '',
      content: {},
      index: 16,
      getStep: (_, featureFlags) => {
        const isEmailConsentRequired = featureFlags.isFeatureOn(requireEmailConsentFeature);
        return isEmailConsentRequired ? 'emailConsent' : 'offer';
      },
    },
    emailConsent: {
      id: 'emailConsent',
      prev: 'phoneNumber',
      next: 'offer',
      index: 16,
      dataKey: 'email-confirm',
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.REGISTRATION_EMAIL_CONFIRM_OPEN,
      },
      content: {
        titleImage: {
          alt: 'email consent',
          src: emailConsent.src,
        },
        title: 'Don’t miss out on a single perk!',
        firstParagraph: `Get access to relationship tips, compatibility insights, personalized horoscopes, and more. <br /><br />
Plus, receive complimentary gifts just for signing up for our email updates`,
        secondParagraph: 'Confirm you want to receive marketing emails so you don’t miss anything',
        continueButtonText: 'Confirm',
        skipButtonText: "I don\'t want updates",
      },
      screenType: StepTypes.EMAIL_CONSENT,
    },
    offer: {
      id: 'offer',
      next: '',
      prev: 'emailConsent',
      index: 0,
      getGoal: (goal: string) => {
        switch (goal) {
          case AreaOfGuidance.LOVE_AND_RELATIONSHIP:
            return 'Find love and build strong relationships';
          case AreaOfGuidance.CAREER_AND_WORK:
            return 'Start perfect career';
          case AreaOfGuidance.DESTINY_AND_LIFE_PATH:
            return 'Find destiny and live happy life';
          case AreaOfGuidance.FUTURE_TELLING:
            return 'Find out your future';
          case AreaOfGuidance.SPIRIT_GUIDANCE:
            return 'Discover spirit guidance';
          default:
            return 'Improve your life';
        }
      },
      analytic: {
        baseEvent: QUIZ_ANALYTIC_EVENTS.REGISTRATION_OFFER_OPEN,
      },
      content: {},
      screenType: StepTypes.OFFER,
    },
  },
};
